require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./general-counsel-0-2-1.json") })
        }
      }, "path---general-counsel-0-2-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---general-counsel-0-2-1!./.cache/json/general-counsel-0-2-1.json
// module id = 442
// module chunks = 231608221292675